import axios from 'axios';
import _ from 'lodash';

import {
  finleyAssert,
  typeguards,
  url as commonUrl,
} from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

export const uploadTapeForLenderVerification = ({
  creditFacilityId,
  selectedReportingDate,
  authToken,
  runInSandboxMode,
}: {
  creditFacilityId: string;
  selectedReportingDate: Util.FullDateStr;
  authToken: string;
  runInSandboxMode: boolean;
}) => {
  return async ({
    artifactId,
    file,
  }: {
    artifactId: string;
    // when null uploder will use last uploaded file for the given artifact Id
    file: File | null;
  }): Promise<{ artifactDocumentId: string; fileVersion: number }> => {
    const url = commonUrl.getBorrowerExpressUrl(
      commonUrl.borrowerExpressPaths.dataTapeUploadCapitalProvider,
    );

    const formData = new FormData();
    formData.append('creditFacilityId', creditFacilityId);
    formData.append('artifactId', artifactId);
    formData.append('reportingDate', selectedReportingDate);

    if (file) {
      formData.append('data-tape', file);
    } else {
      formData.append('useLastUploadedFile', 'true');
    }

    const { data } = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        authorization: `Bearer ${authToken}`,
        'x-finley-execution-mode': runInSandboxMode ? 'sandbox' : 'live',
      },
    });

    const { reportingDate, fileVersion, artifactDocumentId } = data;
    finleyAssert(
      typeguards.isFullDateStr(reportingDate) && _.isInteger(fileVersion),
      'Invalid response from server.',
    );

    return { artifactDocumentId, fileVersion };
  };
};
